import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const BathSection = (): ReactElement => {
  const { t: tBath } = useTranslation('', { keyPrefix: '$pages.$home.$bathSection' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.bathSection' });

  return (
    <section className="base-section bath-section hp-section row-bath clearfix">
      <Link href={tLink('bath')} id="CTA-Bath">
        <div className="hp-top-text">
          <h2>
            <strong>{tBath('bathHeader_1')}</strong> <span>{tBath('bathHeader_2')}</span>
          </h2>
          <p>{tBath('bathDesc')}</p>
          <span className="btn-main">{tBath('shopBath')}</span>
        </div>
        <div className="bath-img">
          <picture>
            <img
              src="/images/homepage/renaissance-hotels-tokyo-milk.png"
              alt="Renaissance Hotels Tokyo Milk"
              width={1600}
              height={600}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
        </div>
        <div className="bath-main">
          <div className="bath-steam-img">
            <picture>
              <img
                src="/images/homepage/renaissance-hotels-robe.webp"
                alt="Renaissance Hotels Grey Robe"
                width={1600}
                height={800}
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
            </picture>
          </div>
        </div>
      </Link>
    </section>
  );
};

export default BathSection;
